<template>
  <Modal title="影票信息" v-model="isDetail" class-name="vertical-center-modal">
    <div class="form-group">
      <div class="label-wrap">订单id：</div>
      <div>{{order.order_id}}</div>
    </div>
    <div class="form-group">
      <div class="label-wrap">图片：</div>
      <div><img style="height: 100px;" :src="cinema.movie_pic" alt=""></div>
    </div>
    <div class="form-group">
      <div class="label-wrap">名称：</div>
      <div>{{cinema.movie_name}}</div>
    </div>
    <div class="form-group">
      <div class="label-wrap">时间：</div>
      <div>{{cinema.create_time}}</div>
    </div>
    <div class="form-group">
      <div class="label-wrap">影院：</div>
      <div>{{cinema.cinema_name}}</div>
    </div>
    <div class="form-group">
      <div class="label-wrap">城市：</div>
      <div>{{cinema.city}}</div>
    </div>
    <div class="form-group">
      <div class="label-wrap">购票座位：</div>
      <div>{{order.seat}}</div>
    </div>
    <div class="form-group" v-if="cinema.realSeat !=null && cinema.realSeat!= ''">
      <div class="label-wrap">实际座位：</div>
      <div>{{cinema.realSeat}}</div>
    </div>
    <div class="form-group">
      <div class="label-wrap">放映时间：</div>
      <div>{{cinema.show_time}}</div>
    </div>
    <div class="form-group">
      <div class="label-wrap">厅/语言：</div>
      <div>{{cinema.hall_name}} {{cinema.language}}</div>
    </div>
    <div class="form-group">
      <div class="label-wrap">地址：</div>
      <div>{{cinema.cinema_address}}</div>
    </div>
    <div class="form-group" v-if="code.length > 0">
      <div class="label-wrap">取票码：</div>
      <div v-for="(item,index) in code" :key="index">{{item.code}}<span v-if="index != code.length-1">，</span></div>
    </div>
    <div class="form-group" v-if="codeImgList.length > 0">
      <div class="label-wrap">取票图片</div>
      <div v-for="(item,index) in codeImgList" :key="index">
        <el-image
          :src="item.url"
          style="width:100px;height: 174px;"
          class="border-radius-6"
          :preview-src-list="previewList"
        />
      </div>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
      </div>
    </div>
    <Spin size="large" fix v-show="loading"></Spin>
  </Modal>
</template>
<script>
import { Modal,Spin } from 'view-design'
import { orderDetail } from '@/api/order'
export default {
  name: "Detail",
  components: {
    Modal,
    Spin
  },
  data: function () {
    return {
      isDetail: false,
      loading:true,
      order:[],
      cinema:[],
      code:[], // 取票码列表
      codeImgList:[], // 取票码图片
      previewList: [] // 预览图片
    }
  },
  methods: {
    init: function (isDetail,row) {
      this.loading = true
      this.isDetail = isDetail
      this.getDetail(row.orderUUID)
    },
    getDetail(orderUUID){
      var that =this;
      orderDetail({orderUUID:orderUUID}).then((response) => {
        //console.log(response)
        that.loading = false
        if(response.code != 200){
          that.$Message.error(response.msg)
          return
        }
        that.order = response.data.order;
        that.cinema = response.data.cinema;
        that.code = response.data.code.code?response.data.code.code:[];
        that.codeImgList = response.data.code.img?response.data.code.img:[];
        const arr = []
        for(let index in that.codeImgList){
          arr.push(that.codeImgList[index].url)
        }
        that.previewList = arr
      }).catch(error => {
        that.loading = false
        console.log(error)
      })
    },
  }
}
</script>


<style scoped>
>>> .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .vertical-center-modal .ivu-modal {
  top: 0;
}
>>> .vertical-center-modal .form-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  width: 100%;
  margin-bottom: 0.4rem;
}
.vertical-center-modal .form-group .label-wrap {
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  width: 1.4rem;
  text-align: right;
  margin-right: 0.32rem;
  font-weight: 600;
}
.vertical-center-modal .form-group .form-item-wrap {
  flex: 1;
  min-width: 0;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  overflow: hidden;
}
.vertical-center-modal .form-group .form-item-wrap.no-border {
  border: none;
}
.vertical-center-modal
  .form-group
  .form-item-wrap
  input::-webkit-input-placeholder {
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
>>> .vertical-center-modal .ivu-modal-footer {
  border-top: none;
  padding: none;
  text-align: right;
}
.border-radius-6{
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/order/modal/Detail.vue